const menu = {
    label: 'Marketing Cloud',
    icon: 'pi pi-fw pi-chart-bar',
    to: '/integrape/marketingcloud',
    rules: ['INTEGRAPE-01', 'INTEGRAPE-02', 'INTEGRAPE-05', 'INTEGRAPE-06', 'INTEGRAPE-07'],
};

export default menu;
